import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import './Pill.scss';

export interface PillProps {
    color?: 'dark-grey' | 'grey' | 'purple' | 'red' | 'yellow';
    textColor?: 'dark-grey';
    className?: Parameters<typeof classNames>[0];
    dataTestid?: String;
}

const Pill: FunctionComponent<PillProps> = ({
    children,
    color = 'grey',
    className,
    dataTestid,
    textColor = '',
}) => {
    return (
        <div
            className={classNames(
                'eds-pill',
                'eds-text-weight--heavy',
                {
                    [`eds-pill--${color}`]: color,
                    [`eds-pill--text-${textColor}`]: textColor,
                },
                className,
            )}
            data-testid={dataTestid}
        >
            {children}
        </div>
    );
};

export default Pill;
